import axios from 'axios'
import nprogress from 'nprogress'

let authHeader

export default {
  addTokenToHeader (token) {
    authHeader = `Bearer ${token}`
  },

  request (method, url, params, data) {
    nprogress.start()

    return axios.request({
      method,
      url,
      params,
      data,
      responseType: 'json',
      headers: {
        Authorization: authHeader
      }
    })
      .then(response => {
        nprogress.done()

        return Promise.resolve(response)
      })
      .catch(error => {
        nprogress.done()

        return Promise.reject(error)
      })
  },

  get (url, params) {
    return this.request('get', url, params)
  },

  post (url, data) {
    return this.request('post', url, {}, data)
  },

  put (url, data) {
    return this.request('put', url, {}, data)
  },

  delete (url) {
    return this.request('delete', url)
  }
}



// WEBPACK FOOTER //
// ./src/modules/api.js